import React from "react";
import GridLoop from "../GridLoop";
import Pagination, { usePagination } from "../Pagination";
import { type ArticlePreviewType } from "~/types";
import Link from "next/link";
const DEFAULT_ITEMS_PER_PAGE = 12;

const AudioGridLayout = ({ articleToShow }) => {
  const showAudioArticle = usePagination(articleToShow, DEFAULT_ITEMS_PER_PAGE);
  return (
    <>
      <div className="article archive mx-auto mt-12 max-w-box px-4 pb-12">
        <div className="article archive mx-auto px-2">
          <GridLoop
            gridloop={showAudioArticle as ArticlePreviewType[]}
            categoria={"category"}
            imageShow={true}
          />
        </div>
      </div>
      <div
        className={`mx-auto mt-6 max-w-box px-4 text-center ${
          articleToShow.length > DEFAULT_ITEMS_PER_PAGE ? "" : "hidden"
        }`}
      >
        <Pagination
          totalResults={articleToShow.length}
          itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
        />
      </div>
    </>
  );
};

export default AudioGridLayout;
